import * as AppConstants from 'app/AppConstants';

const initialState = () => ({
  guides: {},
  activeStepId: null,
  completedSections: new Set(),
});

export default (state = initialState(), action) => {
  switch (action.type) {
    case AppConstants.GUIDE__STATE_LOADED: {
      const completedSections = action.payload.completedSections.reduce(
        (memo, section) => memo.add(section),
        new Set(state.completedSections)
      );
      return {
        ...state,
        completedSections,
      };
    }

    case AppConstants.GUIDE__SECTION_COMPLETED: {
      return {
        ...state,
        completedSections: state.completedSections.add(action.payload.section),
      };
    }

    case AppConstants.GUIDE__STEP_OPENED: {
      return {
        ...state,
        activeStepId: action.payload.stepId,
      };
    }

    case AppConstants.GUIDE__FULFILLED: {
      const {ids} = action.payload;
      const guides = ids.reduce(
        (memo, id) => {
          const guide = memo[id] || {id, view: {count: 0}, fulfill: {count: 0}};
          memo[id] = {
            ...guide,
            view: {
              ...guide.view,
              count: guide.view.count + 1,
            },
            fulfill: {
              ...guide.fulfill,
              count: guide.fulfill.count + 1,
            },
          };
          return memo;
        },
        {...state.guides}
      );

      return {
        ...state,
        guides,
      };
    }

    case AppConstants.GUIDE__LOAD_FINISHED: {
      const {keyedGuides} = action.payload;

      return {
        ...state,
        guides: {
          ...state.guides,
          ...keyedGuides,
        },
      };
    }
    default:
      return state;
  }
};
